<div>
	<select-component
		placeholder="Sort by..."
		[items]="mappedSelectors"
		[value]="value"
		(valueChange)="directionModifierChanged($event)"
	></select-component>
</div>
